import { IconButton } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderProfileIcon } from '@/assets/icons';
import { StyledTooltip } from '@/helpers/styles';

import { OrderProfileServiceFactory } from '../service/OrderProfileServiceFactory';

export const OrderProfileButton = () => {
  const opSvc = useMemo(
    () => OrderProfileServiceFactory.getInstance().createOrderProfileService(),
    [],
  );

  const handleClick = useCallback(
    (event) => {
      event.stopPropagation();
      opSvc.setPanelOpen(true);
    },
    [opSvc],
  );

  const { t } = useTranslation('interface');

  return (
    <StyledTooltip
      style={{ marginLeft: 'auto' }}
      title={t('interface:order_profile.title')}
      placement='bottom'
    >
      <IconButton sx={{ padding: 0 }} onClick={handleClick}>
        <OrderProfileIcon />
      </IconButton>
    </StyledTooltip>
  );
};
